module.exports = __webpack_public_path__ + "static/media/181CO158.0dbdfac2.jpeg";